import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import ViewWidget from "./ViewWidget";
import cloneDeep from "lodash/cloneDeep";

const INSTRUMENT_DEFAULTS = {
  earth: {
    slice_widget: {vignette_function: 'mhd', color: 'kcor', radial_power:-1.5, log_transform:true},
    sim_widget: {domain: 'cor'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  wispr1: {
    slice_widget: {vignette_function: 'coronagraph', color: 'kcor', radial_power:0, log_transform:false},
    // sim_widget: {domain: 'hel'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  wispr2: {
    slice_widget: {vignette_function: 'coronagraph', color: 'kcor', radial_power:0, log_transform:false},
    // sim_widget: {domain: 'hel'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  lasco: {
    slice_widget: {vignette_function: 'coronagraph', color: 'soholasco2', radial_power:0, log_transform:false},
    sim_widget: {domain: 'cor'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  metis: {
    slice_widget: {vignette_function: 'coronagraph', color: 'solar orbiterfsi304', radial_power:0, log_transform:false},
    sim_widget: {domain: 'cor'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  cor2: {
    slice_widget: {vignette_function: 'coronagraph', color: 'soholasco2', radial_power:0, log_transform:false},
    sim_widget: {domain: 'cor'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  nfi: {
    slice_widget: {vignette_function: 'coronagraph', color: 'afmhot', radial_power:0, log_transform:false},
    sim_widget: {domain: 'cor'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
  wfi: {
    slice_widget: {vignette_function: 'coronagraph', color: 'afmhot', radial_power:2.5, log_transform:true},
    sim_widget: {domain: 'hel'},
    view_widget: {symmetric: false, zaxis_min: null, zaxis_max: null}
  },
}

const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  view_widget: {},
}

const DEFAULTS = {
  sim_widget: {
    domain: 'cor',
    time_of_interest: null,
  },
  slice_widget: {
    custom_view: false,
    instrument: 'earth',
    polarized: true,
    longitude: 0,
    b_angle: 0,
    p_angle: 0,
    r_distance: 1,
    occult_inner: null,
    occult_outer: null,
    occult_color: '#FFFFFF',
    radial_power: -1.5,
    vignette_function: 'mhd',
    log_transform: true,
    color: 'kcor',
    show_sim_lower_boundary: false,
    show_sim_upper_boundary: false,
    show_hpc_orientation: false,
  },
  view_widget: {
    fov: 0.53,
    fov_ticks: null,
    show_sun_center: false,
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    zaxis_min: null,
    zaxis_max: null,
    zaxis_ticks: null,
    symmetric: false,
    symmetric_value: null,
    grid: null,
  },
}

const sharedData = {
  slice_widget: {custom_view: null}
}

const flagTriggers = {
  slice_widget: {custom_view: true, instrument: true},
}

const flagDependencies = {
  slice_widget: {custom_view: null, instrument: null},
}

const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = null;
  switch (k) {
    case 'custom_view':
      if (!v) {
        modifiedParams = cloneDeep(INSTRUMENT_DEFAULTS[dependencies.slice_widget.instrument]);
      } else {
        modifiedParams = cloneDeep(PARAM_SCHEMA);
      }
      break;
    case 'instrument':
      modifiedParams = cloneDeep(INSTRUMENT_DEFAULTS[v]);
      break;
    default:
      modifiedParams = cloneDeep(PARAM_SCHEMA);
      break;
  }
  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const WhiteLight = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='white_light'
        toolName='WHITE LIGHT & IMAGERS'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        flagValidators={flagValidators}
        flagDeps={flagDependencies}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        viewWidget={ViewWidget}
      />
    </>

  )
}

export default WhiteLight;